import React, { useContext } from 'react';
import { AppContext } from 'components/Context/AppContext';
import Modals from '../Modals';

import { ReactComponent as DownloadIcon } from 'icons/download-filled-icon.svg';

const DownloadInvoiceAndPdfDataModal = () => {
  const { setShowDownloadInvoiceAndPdfDataModal, showDownloadInvoiceAndPdfDataModal, showToast, setShowSpinner } =
    useContext(AppContext);

  const closeHandler = (state) => {
    setShowDownloadInvoiceAndPdfDataModal((prev) => ({ ...prev, show: state }));
  };

  const downloadInvoiceHandler = async () => {
    try {
      setShowSpinner(true);

      if (showDownloadInvoiceAndPdfDataModal.onDownloadInvoice) {
        await showDownloadInvoiceAndPdfDataModal.onDownloadInvoice();
      }

      showToast({ type: 'success', message: 'Invoice berhasil diunduh!' });

      closeHandler(false);
    } catch (error) {
      showToast({ type: 'error', message: 'Gagal mengunduh invoice. Coba lagi nanti.' });
    } finally {
      setShowSpinner(false);
    }
  };

  const downloadPdfDataHandler = async () => {
    try {
      setShowSpinner(true);

      if (showDownloadInvoiceAndPdfDataModal.onDownloadPdfData) {
        await showDownloadInvoiceAndPdfDataModal.onDownloadPdfData();
      }

      showToast({ type: 'success', message: 'PDF berhasil diunduh!' });

      closeHandler(false);
    } catch (error) {
      showToast({ type: 'error', message: 'Gagal mengunduh data. Coba lagi nanti.' });
    } finally {
      setShowSpinner(false);
    }
  };

  return (
    <Modals setState={closeHandler} title={'Download'} icon={<DownloadIcon />} closeSign>
      <div className="download-invoice-pdf-data">
        <div className="invoice">
          <button className="download-button" type="button" onClick={downloadInvoiceHandler}>
            Download Invoice
          </button>
        </div>
        <div className="pdf-data">
          <button className="download-button" onClick={downloadPdfDataHandler}>
            Download PDF Data
          </button>
        </div>
      </div>
    </Modals>
  );
};

export default DownloadInvoiceAndPdfDataModal;
